module.exports = __webpack_public_path__ + "static/shamel_fahmi-341e73d007589e4f8dc2457233570bca.jpg";